import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';
import get from 'lodash/get'
import SeoHead from '../components/SeoHead'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import ArticlePreview from '../components/ArticlePreview'
import Pagination from '../components/Pagination'
import styles from '../pages/blog.module.css'


const Grid = styled.div`
  display: grid;
  max-width: 800px;
  margin: 0 auto;
  grid-template-columns: repeat(1, 1fr);
  min-height: 100vh;
  width: 100%;
  grid-gap: 24px;

  ${breakpoint('tablet')`
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 48px;
  `}
`

const BlogListTemplate = ({ data, pageContext }) => {
  const siteTitle = get(data, 'site.siteMetadata.title')
  const posts = get(data, 'allContentfulBlogPost.edges')
  const { currentPage } = pageContext

  return (
    <Layout>
      <div style={{ background: '#fff' }}>
        <SeoHead title={`${siteTitle}/blog`} />
        {currentPage === 1 && <Hero />}
        <div className="wrapper">
          <Grid>
            {posts.map(({ node }) => {
              return (
                <div key={node.id}>
                  <ArticlePreview article={node} />
                </div>
              )
            })}
          </Grid>
        </div>
        <div className="container u-mb1">
          <Pagination context={pageContext} />
        </div>
      </div>
    </Layout>
  )
}

BlogListTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.shape({
    limit: PropTypes.number,
    skip: PropTypes.number,
    numPages: PropTypes.number,
    currentPage: PropTypes.number,
  }),
}

export default BlogListTemplate

export const pageQuery = graphql`
  query BlogPagePagQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogPost(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [updatedAt], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          slug
          title
          category
          createdAt
          updatedAt(formatString: "MMMM Do, YYYY")
          legacyTitle
          featureImage {
            id
            fluid(maxWidth: 350, resizingBehavior: SCALE) {
              src
              srcSet
              sizes
              srcWebp
              tracedSVG
              aspectRatio
            }
          }
          legacy
          intro {
            id
          }
          childContentfulBlogPostIntroTextNode {
            childMarkdownRemark {
              excerpt
            }
          }
        }
      }
    }
  }
`
